"use client";
import { jsx } from "react/jsx-runtime";
import { useSvg } from "../../../hooks/useSvg.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { rem, Box } from "@mantine/core";
import { forwardRef } from "react";
import { I as IllustrationsList } from "./illustrations/index.js";
import '../../../assets/Illustration.css';const root = "_root_190cg_2";
const IllustrationStyles = {
  root
};
const _Illustration = forwardRef((props, ref) => {
  const {
    name = "airplane",
    className,
    width = "auto",
    height = "auto",
    style,
    variant = "light",
    mod,
    ...rest
  } = props;
  const Svg = useSvg(name, IllustrationsList);
  const styleVariables = {
    "--passed-height": rem(height),
    "--passed-width": rem(width)
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...rest,
      ref,
      className: `${IllustrationStyles.root} ${className}`,
      style: { ...styleVariables, ...style },
      mod: { variant, ...mod },
      children: Svg
    }
  );
});
_Illustration.displayName = "Illustration";
const Illustration = sharedHandler(_Illustration);
Illustration.displayName = _Illustration.displayName;
export {
  IllustrationStyles as I,
  Illustration as default
};
